import React, { memo } from 'react';
import { Modal, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

const ModalSaveBeforeLeave = memo(({ isOpen, onCancel, onConfirm }) => {
    const { t } = useWeb5Context();
    return (
        <Modal
            isOpen={isOpen}
            size="small"
            title={t('label_unsaved_filters')}
            confirmText={t('action_save_changes')}
            cancelText={t('action_discard_changes')}
            onCancel={onCancel}
            onConfirm={onConfirm}
            useCornerClose={false}
        >
            <Text>{t('label_unsaved_forcebi_dashboard_filters')}</Text>
        </Modal>
    );
});

export default ModalSaveBeforeLeave;
